module.exports = __webpack_public_path__ + "img/piyao-suject-icon-right-wap.06b15245.png";